import { ComponentModal, ICustomer } from "../common/interfaces";
import { useModalStore } from "../context/modalStore";

/**
 * Antepone el modal de identificación de cliente (CustomerIdentification)
 * antes de abrir Finish/OrderOptions, a menos que el cliente activo ya
 * sea uno real (id !== 1, distinto del genérico "Público en General").
 */
export const useCustomerGate = () => {
  const modalManager = useModalStore();

  const openWithCustomerGate = (
    nextModal: ComponentModal,
    nextParams: Record<string, any>,
    customer: ICustomer
  ) => {
    if (customer.id === 1) {
      modalManager.openModal(ComponentModal.CustomerIdentification, { nextModal, nextParams });
      return;
    }
    // Ya identificado: incluir `customer` siempre, sin depender de que el
    // caller ya lo haya puesto en nextParams (headerCartView.tsx no lo hacía).
    modalManager.openModal(nextModal, { ...nextParams, customer });
  };

  return { openWithCustomerGate };
};
